import { z } from "zod/v4";

import { AgenticLogicSdkReadResultDescriptions } from "../../../descriptions/agentic-logic.describe";
import { assertDescriptions } from "../../../descriptions/types";

// ---------------------------------------------------------------------------
// Resolved reads
// ---------------------------------------------------------------------------

/**
 * What every AgenticLogicSdkReadPort method resolves to: the response plus the
 * hash of the canonicalized request that produced it. The hash is the SDK's
 * per-invocation memoization key — it is NOT a storage key, and nothing
 * persists an ordered log of these any more.
 */
export interface AgenticLogicRecordedRead<T> {
  requestHash: string;
  response: T;
}

export const AgenticLogicSdkReadResultSchema = z
  .object({
    requestHash: z
      .string()
      .describe(AgenticLogicSdkReadResultDescriptions.requestHash),
    response: z
      .unknown()
      .describe(AgenticLogicSdkReadResultDescriptions.response),
  })
  .describe(AgenticLogicSdkReadResultDescriptions._schema);
export type AgenticLogicSdkReadResult = z.infer<
  typeof AgenticLogicSdkReadResultSchema
>;

assertDescriptions<
  typeof AgenticLogicSdkReadResultDescriptions,
  AgenticLogicSdkReadResult
>();
